module.exports = __webpack_public_path__ + "img/sphere06-graph.56c7951a.png";